import { CustomerFormFields } from '@/types/customers';

export const initialCustomerForm: CustomerFormFields = {
  uuid: '',
  firstName: '',
  middleName: '',
  lastName: '',
  phone: '',
  confirmPhone: '',
  dob: '',
  email: '',
  confirmEmail: '',
  ssn: '',
  confirmSsn: '',
  company: '',
  advisors: [],
  currentAddress: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    postalCode: '',
  },
  sameMailingAddress: true,
  mailingAddress: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    postalCode: '',
  },
  min: '0',
  max: '0',
};
